import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function UrgencyBar() {
  // Start with 14 minutes and 55 seconds (895 seconds)
  const [timeLeft, setTimeLeft] = useState(895);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `00:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-urgency text-white py-2 px-4 shadow-md" data-id="element-203">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center text-center gap-2 text-sm sm:text-base font-medium" data-id="element-204">
        <div className="flex items-center gap-2" data-id="element-205">
          <span className="font-bold tracking-wider" data-id="element-206">
            ¡OFERTA DE LANZAMIENTO!
          </span>
          <Timer className="w-4 h-4 animate-pulse" data-id="element-207" />
        </div>
        <span data-id="element-208">
          El 93% de descuento expira en:{' '}
          <span className="font-mono font-bold bg-white/20 px-2 py-0.5 rounded" data-id="element-209">
            {formatTime(timeLeft)}
          </span>
        </span>
        <span className="text-white/90 text-xs sm:text-sm hidden md:inline" data-id="element-210">
          (Solo disponible para las primeras 50 copias de hoy)
        </span>
      </div>
    </div>;
}